import { sessionVariable } from "../../utils/enums/sessionStorage";
import { ifrsService } from "../Gateways/ifrsService";

// Call logout API on server to invalidate session/token
export const upsertSession = async (payload) => {
    try {
        const response = await ifrsService(`/SessionToken/Upsert`, "POST", payload);
        return response;
    } catch (error) {
        return error;
    }
}

export const getUserInfo = () => {
    return JSON.parse(getSessionStorage({ key: sessionVariable.userInfo }))
}
export const getCompanyProfile = () => {
    return JSON.parse(getSessionStorage({ key: sessionVariable.companyProfile })) || {}
}
export const getSelectLease = () => {
    return JSON.parse(getSessionStorage({ key: sessionVariable.selectLease }))
}
export const getAppFlow = () => {
    return JSON.parse(getSessionStorage({ key: sessionVariable.flow }))
}

export const setSessionStorage = ({ key, value }) => {
    sessionStorage.setItem(key, JSON.stringify(value));
}
export const getSessionStorage = ({ key }) => {
    return (sessionStorage.getItem(key));
}

export const removeSessionStorageVariable = ({ key }) => {
    sessionStorage.removeItem(key);
}
export const clearAllSessionStorage = () => {
    sessionStorage.clear();
}